import { useEntityOptions } from 'data/entity-sources/useEntityOptions';
import type { EntitySource } from 'data/entity-sources/types';

import { DataTableAsyncFilter } from './DataTableAsyncFilter';

type DataTableEntityFilterProps = {
    source: EntitySource;
    title?: string;
    selectedValues: string[];
    onChange: (values: string[]) => void;
};

/**
 * Le filtre asynchrone existant, alimenté par une source de collection au lieu d'un `loadOptions`
 * écrit par la page.
 *
 * C'est ici que le hook est appelé — pas dans la page. C'est ce qui permet à une configuration de
 * colonne de rester un objet inerte : plus de `useCallback` à stabiliser, plus de fonction à faire
 * descendre en props jusqu'à `buildXColumns`, et plus d'oubli possible du second argument
 * `unresolvedValues`, dont dépend l'affichage des libellés d'une sélection venue d'une URL.
 */
export function DataTableEntityFilter({ source, title, selectedValues, onChange }: DataTableEntityFilterProps) {
    const loadOptions = useEntityOptions(source);

    return (
        <DataTableAsyncFilter
            title={title ?? source.labels.plural}
            selectedValues={selectedValues}
            onChange={onChange}
            loadOptions={loadOptions}
        />
    );
}
